import { render, staticRenderFns } from "./TaxCreate.vue?vue&type=template&id=3931498f&"
import script from "./TaxCreate.vue?vue&type=script&lang=ts&"
export * from "./TaxCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports